import { Inject, Injectable, signal } from '@angular/core';
import createKindeClient from '@kinde-oss/kinde-auth-pkce-js';
import { BehaviorSubject, filter, lastValueFrom } from 'rxjs';
import { Environment, ENVIRONMENT } from '@promojds-front/environments';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public isKindeLoading = signal(false);
  private kinde: any;
  private isCreating = false;
  private kinde$ = new BehaviorSubject<any>(undefined);

  constructor(@Inject(ENVIRONMENT) private environment: Environment) {
    this.setupKinde();
  }

  private async waitForKinde(): Promise<void> {
    if (!this.kinde) {
      return lastValueFrom(this.kinde$.pipe(filter((k) => !!k)));
    }
  }

  private async setupKinde(): Promise<void> {
    if (!this.kinde && !this.isCreating) {
      this.isKindeLoading.set(true);
      this.isCreating = true;
      this.kinde = await createKindeClient({
        client_id: this.environment.kindeClientId,
        domain: this.environment.kindeAuthDomain,
        redirect_uri: window.location.origin,
        logout_uri: this.environment.kindeLogoutRedirectUrl,
        scope: 'openid profile email offline',
        is_dangerously_use_local_storage: true
      });
      this.kinde$.next(this.kinde);
      this.kinde$.complete();
      this.isKindeLoading.set(false);
    }
  }

  public async login(): Promise<void> {
    await this.waitForKinde();
    return this.kinde?.login();
  }

  public async logout(): Promise<void> {
    await this.waitForKinde();
    return this.kinde?.logout();
  }

  public async isAuthenticated(): Promise<boolean> {
    await this.waitForKinde();
    console.log('Authenticating......', await this.kinde?.isAuthenticated());
    return this.kinde?.isAuthenticated();
  }

  public async getUser(): Promise<any | undefined> {
    await this.waitForKinde();
    return this.kinde?.getUserProfile();
  }

  public async isAdmin(): Promise<boolean> {
    await this.waitForKinde();
    return this.kinde?.getClaim('x-hasura-roles')
      ?.value?.some((role: { key: string }) => role.key === 'admin');
  }

  public async getToken(): Promise<string> {
    return this.kinde?.getToken();
  }
}
